<ziro-self-serve-top-bar></ziro-self-serve-top-bar>

<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

<div [hidden]="isLoading">
  <ziro-self-serve-user-details-back
    [link]="'/self-serve/user/' + user?.ref.username"
  ></ziro-self-serve-user-details-back>

  <ziro-self-serve-user-details-header
    [heading]="headerTranslationKey | translate"
    [headingDataAutomation]="headingDataAutomation"
  ></ziro-self-serve-user-details-header>

  <ziro-text [fieldId]="'selfServeVoicemailPinResetComplexity'"></ziro-text>
  <ziro-text [fieldId]="'pin'"></ziro-text>
  <ziro-text [fieldId]="'pinConfirm'"></ziro-text>

  <div class="col-sm-12 text-end">
    <ziro-submit-button
      [isPending]="isSubmitting"
      [isDisabled]="isSubmitting"
      [cssClass]="'me-2'"
      [icon]="ziroIcons.REFRESH"
      [dataAutomation]="'self-serve-pin-reset-button'"
      [buttonStyle]="ButtonStyles.OUTLINE_PRIMARY"
      [label]="'tkey;selfserve.user.reset.button'"
      [iconPending]="ziroIcons.SAVING"
      [formSubmitSubject]="_validateAndSubmitSource"
    ></ziro-submit-button>
  </div>
</div>
